<template>
  <Dashboard />
</template>

<script>
import Dashboard from '../components/Dashboard/index';

export default {
  components: {
    Dashboard,
  },
  computed: {
  },
}
</script>
